import {SALE_URL_CATEGORY_SEGMENT} from "../../config/constants"

const isSalePage = (categoryUrlSegment: string) => {
    return categoryUrlSegment.includes(SALE_URL_CATEGORY_SEGMENT)
}

export default isSalePage
